import React from "react";

/**
 * AADHQ logo. Default size = 36px (header). Use `size` prop to override.
 * Includes the brand name "Gestion Dek" aside the logo (hidden when `withText={false}`).
 */
export default function Logo({ size = 36, withText = true, className = "", textClassName = "", invert = false }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        src="/logo-aadhq.png"
        alt="AADHQ — Association Arbitres Dek Hockey du Québec"
        width={size}
        height={size}
        className="block shrink-0"
        style={{ width: size, height: size }}
      />
      {withText && (
        <div className={`leading-none ${textClassName}`}>
          <span className="font-semibold text-[var(--text)]" style={{ fontSize: `${Math.round(size * 0.5)}px`, letterSpacing: "-0.02em" }}>
            Gestion
          </span>
          <span className="block font-medium uppercase tracking-[0.28em] text-[var(--muted)] mt-0.5" style={{ fontSize: `${Math.max(9, Math.round(size * 0.26))}px`, fontFamily: "'Geist Mono', ui-monospace, monospace" }}>
            Dek
          </span>
        </div>
      )}
    </div>
  );
}
